import React from 'react';
import MWSVG from './svg';

type Props = {
    text: string;
    className?: string;
};

const KEY: React.FC<Props> = ({ text, className }) => {
    return (
        <p className={`mb-2 fw-600 dark:text-[#D7DEE5] flex xl:items-center lg:items-start md:items-center items-start ${className}`}>
            <MWSVG id="tabler-icon-square-rounded-check" svgClassName="me-2.5" />
            {text}
        </p>
    );
};

export default KEY;
